import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { ErrorComponent } from './error.component';
import { ErrorDialogComponent } from './error.dialog/error.dialog.component';
import { ResponseErrorDialogComponent } from './response-error.dialog/response-error.dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatListModule,
    MatDialogModule,
    SharedModule
  ],
  declarations: [
    ErrorComponent,
    ErrorDialogComponent,
    ResponseErrorDialogComponent
  ],
  exports: [
    ErrorComponent,
    ErrorDialogComponent,
    ResponseErrorDialogComponent
  ]
})
export class ErrorModule { }
